import { render, staticRenderFns } from "./CargoExpenseTypeDropdown.vue?vue&type=template&id=3d6229fe"
import script from "./CargoExpenseTypeDropdown.vue?vue&type=script&lang=js"
export * from "./CargoExpenseTypeDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports